import React from 'react'
import islands from '@constants/islands'
import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import countries from '@constants/countries'
import { BUSINESS_FIELDS } from '@modules/form-wizard/utils'
import convertToBase64 from '@helpers/file-to-base64'

export default class RadioactiveMaterial extends React.Component {
  resource = '/moen/health/radioactive_materials'
  form_key = 'radioactive_material'
  defaults = {}

  // Delete lines as needed
//   fee = 99
  free = true
  postpaid = false
  skip_location = true
  hide_buttons = false
  custom_actions = []

  validate = async form => {
    const update = {}
    const packageTypeArray = Array.from(form.package_type_list || []) // Convert Checklist of type Set to Array
    update.package_type_list = packageTypeArray

    // Validation: Ensure at least one package type is selected
    if (packageTypeArray.length === 0) {
      return 'No package types were selected'
    }

    // Validation: Ensure that at least one option is checked for the application type checklist
    if (form.application_type.trim() === '') {
      return 'No application type was selected'
    }


    if(form.instrument_handling_list[0]) {
      let index = 0
      update.instrument_handling_list = []

      for (let row of form.instrument_handling_list) {
        const {
          qualification_upload,
          dosimetry_results_upload,
          ...item
        } = row
        index ++

        if (qualification_upload) {
          item.title_qualification = `${item.first_name} ${item.last_name} Qualification - ${index}`
          item.desc_qualification = `Qualification for ${item.first_name} ${item.last_name} - ${index}`
          item.title_dosimetry = `${item.first_name} ${item.last_name} Dosimetry Results - ${index}`
          item.desc_dosimetry = `Dosimetry Results for ${item.first_name} ${item.last_name} - ${index}`
          item.qualification_upload = await convertToBase64(qualification_upload)
          item.dosimetry_results_upload = await convertToBase64(dosimetry_results_upload)
          update.instrument_handling_list.push(item)
        }
      }
    }

    if(form.instrument_leak_test_list[0]) {
      let index = 0
      update.instrument_leak_test_list = []

      for (let row of form.instrument_leak_test_list) {
        const {
          leak_test_upload,
          ...item
        } = row
        index ++

        if (leak_test_upload) {
          item.title = `Specification - ${item.specification} (${index})`
          item.desc = `Leak Test for ${item.specification} (${index})`
          item.leak_test_upload = await convertToBase64(leak_test_upload)
          update.instrument_leak_test_list.push(item)
        }
      }
    }

    if(form.consignee_list[0]) {
      let index = 0
      update.consignee_list = []

      for (let row of form.consignee_list) {
        const {
          authorization_upload,
          ...item
        } = row
        index ++

        if (authorization_upload) {
          item.title = `Authorization - ${item.name} (${index})`
          item.desc = `Authorization for ${item.name} (${index})`
          item.authorization_upload = await convertToBase64(authorization_upload)
          update.consignee_list.push(item)
        }
      }
    }

    if(form.supplier_list[0]) {
      let index = 0
      update.supplier_list = []

      for (let row of form.supplier_list) {
        const {
          authorization_upload,
          ...item
        } = row
        index ++

        if (authorization_upload) {
          item.title = `Authorization - ${item.name} (${index})`
          item.desc = `Authorization for ${item.name} (${index})`
          item.authorization_upload = await convertToBase64(authorization_upload)
          update.supplier_list.push(item)
        }
      }
    }

    return update
  }

  foremost = null

  fields = form => {
    const applicantInfo = () => {
        if (['import', 'export'].includes(form.application_type)) {
            return [
                "::Applicant Information",
                {
                    name: "organization_name",
                    label: "Name of Organization",
                    hint: 'Leave blank if not applicable',
                    required: false,
                },
                {
                    name: 'island',
                    label: 'Island',
                    options: islands,
                },
                {
                    name: "state",
                    required: false,
                },
                {
                    name: "province",
                    required: false,
                },
                {
                    name: 'street_address',
                    label: 'Street Address',
                    hint: "eg. Centerville, Collins Avenue, #5",
                },
                {
                    name: "postal_code",
                },
            ]
        } else {
            return []
        }
    }
    
    return [
        ...BUSINESS_FIELDS(form),
        {
            name: "application_type",
            label: "Type of Application",
            type: "checklist",
            single: true,
            options: [
                { label: "Import", value: "import" },
                { label: "Export", value: "export" },
                { label: "Original", value: "original" },
                { label: "Amendment", value: "amendment" },
            ],
        },
        // {
        //     name: 'COA_number',
        //     label: 'Certificate of Authorization (COA) Number',
        //     hide: form.application_type !== 'amendment',
        // },
        ...applicantInfo(),
        {
            name: "consignee_list",
            label: "Final Consignee",
            hide: form.application_type !== 'export',
            fields: [
                {
                    name: "name",
                    label: "Name"
                },
                {
                    name: "address",
                    label: "Address",
                    required: false,
                },
                {
                    name: "country",
                    label: "Country",
                    options: countries
                },
                {
                    name: "contact_first_name",
                    label: "Contact First Name"
                },
                {
                    name: "contact_middle_name",
                    label: "Contact Middle Name",
                    required: false
                },
                {
                    name: "contact_last_name",
                    label: "Contact Last Name"
                },
                {
                    name: "contact_email",
                    label: "Contact Email",
                    type: "email"
                },
                {
                    name: "authorization_number",
                    hint: "Authorization Number issued to the consignee by the regulatory authority in the country of destination (if applicable)",
                    // required: false,
                },
                {
                    name: "authorization_expiry_date",
                    label: "Authorization Expiry Date",
                    type: "date",
                    showYearDropdown: true,
                    // required: false,
                },
                {
                    name: "authorization_upload",
                    label: "Copy of Authorization Documentation",
                    hint: "Copy of Authorization issued to the consignee by the regulatory authority in the country of destination (if applicable)",
                    type: "file:all",
                },
                {
                    name: "additional_info",
                    label: "Additional Information",
                    type: "textarea",
                    required: false,
                }
            ],
            hint: "Additional consignees may be added"
        },
        {
            name: "supplier_list",
            label: "Supplier(s)",
            hide: form.application_type !== 'import',
            fields: [
                {
                    name: "name",
                    label: "Name"
                },
                {
                    name: "address",
                    label: "Address",
                    required: true,
                },
                {
                    name: "country",
                    label: "Country",
                    options: countries
                },
                {
                    name: "contact_first_name",
                    label: "Contact First Name"
                },
                {
                    name: "contact_middle_name",
                    label: "Contact Middle Name",
                    required: false
                },
                {
                    name: "contact_last_name",
                    label: "Contact Last Name"
                },
                {
                    name: "contact_email",
                    label: "Contact Email",
                    type: "email"
                },
                {
                    name: "authorization_number",
                    hint: "Authorization Number issued to the consignee by the regulatory authority in the country of destination (if applicable)",
                    // required: false,
                },
                {
                    name: "authorization_expiry_date",
                    label: "Authorization Expiry Date",
                    type: "date",
                    showYearDropdown: true,
                    // required: false,
                },
                {
                    name: "authorization_upload",
                    label: "Copy of Authorization Documentation",
                    hint: "Copy of Authorization issued to the consignee by the regulatory authority in the country of destination (if applicable)",
                    type: "file:all",
                },
                {
                    name: "additional_info",
                    label: "Additional Information",
                    type: "textarea",
                    required: false,
                }
            ],
            hint: "Additional consignees may be added"
        },
        {
            name: "radioactive_material_list",
            label: "Radioactive Material(s)",
            hint: "Description of Radioactive Material(s) and/or Radiation Generator(s)",
            fields: [
                {
                    name: "name",
                    label: "Name",
                },
                {
                    name: "form",
                    label: "Form",
                    options: [
                        { label: "Gas", value: "gas" },
                        { label: "Liquid", value: "liquid" },
                        { label: "Solid", value: "solid" },
                    ]
                },
                {
                    name: "serial_number",
                    label: "Serial Number(s)",
                    type: "textarea",
                    hint: "List all serial numbers if applicable"
                },
                {
                    name: "instrument_source_specification",
                    label: "Instrument/Source Specification",
                    type: "textarea",
                    hint: "Specification of each instrument or source"
                },
                {
                    name: "activity",
                    label: "Activity (Units)",
                    hint: "Include the Units of measurement for the activity (e.g. 5 curies, 185 becquerels, etc.)",
                    type: 'alphanumeric',
                },
                {
                    name: "quantity",
                    label: "Quantity (Units)",
                    type: 'alphanumeric',
                },
                {
                    name: "country_of_origin",
                    label: "Country of Origin",
                    options: countries,
                    multi: true,
                    hint: "If more than one country of origin, select all that apply",
                },
                {
                    name: "intended_end_use",
                    type: "textarea",
                    hint: "Please provide a clear description of what this will be used for"
                },
                {
                    name: "intended_end_use_location_name",
                    label: "Name/Island of intended end use location",
                },
                {
                    name: "intended_end_use_location_address",
                    label: "Address of intended end use location",
                },
                {
                    name: 'intended_end_use_location_latitude',
                    label: 'GPS Coordinates (Latitude) for intended end use location',
                    type: 'number'
                },
                {
                    name: 'intended_end_use_location_longitude',
                    label: 'GPS Coordinates (Longitude) for intended end use location',
                    type: 'number'
                }
            ]
        },
        {
          name: "instrument_leak_test_list",
          label: "Leak Test Documentation",
          fields: [
            {
              name: "specification",
              label: "Specification of Instrument/Source",
            },
            {
                name: "leak_test_upload",
                label: "Copy of most recent leak test performed on this instrument",
                type: "file:all",
            },
          ],
          hint: "Leak test documentation for each instrument/source listed above"
        },
        // {
        //     name: "intended_end_use_location_list",
        //     label: "Intended End Use Location(s)",
        //     fields: [
        //         {
        //             name: "name",
        //             label: "Name/Island",
        //         },
        //         {
        //             name: "address",
        //         },
        //         {
        //             name: 'latitude',
        //             label: 'GPS Coordinates (Latitude)',
        //             type: 'number'
        //         },
        //         {
        //             name: 'longitude',
        //             label: 'GPS Coordinates (Longitude)',
        //             type: 'number'
        //         }
        //     ],
        //     hint: "Additional locations may be added"
        // },
        {
            name: "shipping_company_list",
            label: "Shipping Company(ies) Used",
            fields: [
                {
                    name: "name",
                },
                {
                    name: "street",
                },
                {
                    name: "city",
                },
                {
                    name: "island",
                    options: islands
                },
                {
                    name: "province",
                    required: false,
                },
                {
                    name: "telephone",
                    type: "phone"
                },
                {
                    name: "email",
                    type: "email"
                },
                {
                    name: "tracking_number",
                    // type: "integer"
                    hint: "Tracking number for the shipment"
                }

            ],
            hint: "Additional shipping/courier services may be added"
        },

        "::Shipment",
        {
            name: "shipping_import",
            label: "Proposed Date of Initial Export/Import",
            type: "date",
            showYearDropdown: true,
            hint: "If only one (1) item is being received/sent, the initial and final dates will be the same",
        },
        {
            name: "shipping_export",
            label: "Proposed Date of Final Export/Import",
            type: "date",
            showYearDropdown: true,
            hint: "If only one (1) item is being received/sent, the initial and final dates will be the same",
        },

        "::Security, Packaging, and Transport",
        {
            name: "package_type_list",
            label: "Type of package required by the IAEA",
            multi: true,
            type: "checklist",
            // required: false,
            options: [
                { label:'N/A', value: 'n/a' },
                { label: 'IP-1', value: 'IP-1' },
                { label: 'IP-2', value: 'IP-2' },
                { label: 'IP-3', value: 'IP-3' },
                { label: 'Type A', value: 'Type A' },
                { label: 'Type B', value: 'Type B' },
                { label: 'Type C', value: 'Type C' },
                { label: 'Excepted', value: 'Excepted' }
            ],
            hint: "Packages containing fissile material or uranium hexafluouride are subject to additional requirements."
        },

        "::Additional Information",
        {
            name: "instrument_handling_list",
            label: "List of all individuals that will be handling the instrument/radioactive material and qualifications to do the same",
            fields: [
                {
                    name: "first_name",
                },
                {
                    name: "middle_name",
                    required: false
                },
                {
                    name: "last_name",
                },
                {
                    name: "qualifications",
                    type: "textarea"
                },
                {
                    name: 'qualification_upload',
                    label: 'Upload of documentation supporting the qualifications of the handler(s)',
                    type: 'file:all'
                },
                {
                    name: "dosimetry_results_upload",
                    label: "Copy of the most recent dosimetry results",
                    type: "file:all"
                }
            ],
        },

        "::SPACER",
        "::Uploads",
        {
            name: "facility_drawing_upload",
            label: "Copy of detail drawings of the facility where the instrument/radioactive material will be held",
            hide: form.application_type !== 'export',
            type: "file:all",
            key: 'image.0'
        },
        {
            name: "facility_drawing_2_upload",
            label: "Copy of detail drawings of the additional facility where the instrument/radioactive material will be held",
            hide: form.application_type !== 'import',
            type: "file:all",
            key: 'image.1',
            required: false,
        },
        {
            name: "accident_drawing_upload",
            label: "Copy of any accident reports logged by worker &/or the general public involving the instrument",
            required: false,
            type: "file:all",
            key: 'image.2'
        },
        {
            name: "policy_manual_decon_upload",
            label: "Policy and procedure manuals for decontamination, dismantling and removal of radioactive materials, waste, components and structures",
            type: "file:all",
            key: 'image.3'
        },
        {
            name: "policy_manual_damage_upload",
            label: "Policy and procedure manuals for reporting damage, theft and loss of instrument/radioactive material",
            type: "file:all",
            key: 'image.4'
        },
        {
            name: 'emergency_preparedness_plan_upload',
            label: 'Policy and procedure manuals for handling emergencies',
            type: 'file:all',
            key: 'image.5',
            hint: "Provide a copy of the policy and procedure manual(s) detailing the emergency preparedness plan for each site where radioactive and nuclear materials will be used or stored"
        },
        {
            name: 'insurance_doc_upload',
            label: 'Insurance documentation for transport, use, and storage',
            type: 'file:all',
            key: 'image.6',
            hint: "Provide a copy of the insurance documentation covering the transport, use, and storage of radioactive and nuclear materials at each site"
        }
    ]
  }
  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
